module.exports = __webpack_public_path__ + "files/0a01a89318105d7f8c3f729a24b60257.png";